import 'zone.js'
import { genVr } from './utils';


type Ctx = {
  version: string;
  [key: string]: any;
};

const zone = Zone.current.fork({
  name: 'ctxZone',
});

export const withCtx = async <R, M = {}>(
  ctx: Partial<Ctx & M>,
  block: (ctx: Ctx & M) => R
): Promise<R> => {
  const localCtx = { version: genVr(), ...ctx };
  
  return zone.run(async () => {

    Zone.current['ctx'] = localCtx;

    return await block(localCtx as any)
  });
};

export const getCtx = <M = {}>() => Zone.current['ctx'] as Ctx & M;
export const setCtx = <M = {}>(ctx: Ctx & M) => {
  Zone.current['ctx'] = ctx;
};